import * as React from 'react';
import Helmet from 'react-helmet';
import * as url from 'url';
import AppConfig from '../AppConfig';
const Seo = ({ pathname, title, description, siteName, keywords = '', image, meta, children, ...props }) => {
    const finalKeywords = Array.isArray(keywords) ? keywords.join(', ') : keywords;
    return (React.createElement(AppConfig, null, ({ lang, rootUrl }) => {
        const pageUrl = pathname && (rootUrl ? url.resolve(rootUrl, pathname) : pathname);
        return (React.createElement(Helmet, Object.assign({}, props),
            title && React.createElement("title", null, title),
            React.createElement("html", { lang: lang }),
            description && React.createElement("meta", { name: "description", content: description }),
            finalKeywords.length > 0 && (React.createElement("meta", { name: "keywords", content: finalKeywords })),
            siteName && React.createElement("meta", { property: "og:site_name", content: siteName }),
            React.createElement("meta", { property: "og:type", content: "website" }),
            title && React.createElement("meta", { property: "og:title", content: title }),
            pageUrl && React.createElement("meta", { property: "og:url", content: pageUrl }),
            description && (React.createElement("meta", { property: "og:description", content: description })),
            image && React.createElement("meta", { property: "og:image", content: image }),
            (meta || []).map((x, idx) => (React.createElement("meta", Object.assign({ key: idx }, x)))),
            children));
    }));
};
export default Seo;
//# sourceMappingURL=index.js.map